import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { GeneralService } from '../../../services/formulacion/general.service';
import { TraspasoService } from '../../../services/formulacion/traspaso.service';
import { environment } from '../../../../environments/environment';
import { UtilHelper } from '../../../_helpers/util';
import { PoaTechoService } from 'src/app/services/service.index';
declare var jQuery: any;
declare var toastr;

@Component({
  selector: 'app-traspasos-financiera',
  templateUrl: './traspasos-financiera.component.html',
  styleUrls: [],
  providers: [GeneralService, TraspasoService]
})
export class TraspasosFinancieraComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  @ViewChild(DxScrollViewComponent) scrollView: DxScrollViewComponent;
  dataResourceAgreacion: any;
  tipo_agregacion_id: number = 1;
  title: string;
  scrollByContent = true;
  scrollByThumb = true;
  estados: any[];
  dataResource: any[];
  dataIntervenciones: any[];
  popupVisibleRet: boolean = false;
  popupVisibleChk: boolean = false;
  baseUrl: string;
  traspaso_id: number;
  intervencion_id: number;
  estado_id: number;
  model: any = {
    id: '',
    tipo_traspaso: 'D',
    estado_id: '',
    descripcion: '',
    inciso: ''
  }
  esNuevaObs: boolean = false;
  dataResourceObs: any[];
  tipoSeg: any = [];
  incisos: any = [];
  clicked: boolean = false;
  hasError: any = {};
  rol: number = 0;
  oTraspasos: any[];
  popupVisibleO: boolean = false;
  ttId: number;
  
  constructor(private _gs: GeneralService, private _trs: TraspasoService, private _ts: PoaTechoService) {
    this.baseUrl = environment.apiEndpoint;
    this.intervencion_id = 0;
    this.estado_id = 24;
    this.tipo_agregacion_id = 1;
    this.getTraspasos();
    this.getEstadosTByUsuario();
    this.getTipoAgregacion();
    this.getIncisosPpto();
    this.resetErrors();
  }

  ngOnInit() {
  }

  getIntervenciones() {
    let u = JSON.parse(localStorage.getItem('u'));
    if (u != null) {
      this._gs.getTechoByUO(u.unidad).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            result.data.unshift({ id: 0, descripcion_techo: 'Todos' });
            this.dataIntervenciones = result.data;
          } else {
            this.dataIntervenciones = [];
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  getTraspasos() {
    let u = JSON.parse(localStorage.getItem('u'));
    if (this.intervencion_id != undefined && this.intervencion_id != null) {
      this._trs.getTraspasosPorAprobar(this.intervencion_id, this.estado_id, this.tipo_agregacion_id).subscribe((response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResource = result.data;
          this.rol = u.rol;
        } else {
          this.dataResource = [];
        }
      },
        (error) => { console.log('Error', error); });
    } else {
      this.intervencion_id = 0;
    }
  }

  refreshDataGrid(e) {
    this.estado_id = e.value;
    this.getTraspasos();
    this.dataGrid.instance.refresh();
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  showModalEdit(id: number) {    
    this.title = 'EDITAR TRASPASO';
    this.model.id = id;
    this.getEstadosTByUsuarioSeguimiento();
    this._trs.getArobadoFin(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.popupVisibleChk = true;
          this.model = result.data;          
          this.model.estado_id = 25;
        }
      });
  }

  getTipoAgregacion() {
    this._ts.getTipoAgregacion().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          
          this.dataResourceAgreacion = result.data;

        } else {
          this.dataResourceAgreacion = [];
        }
      },
      (error) => { console.log('Error', error); });
  }

  returnTraspaso() {
    this._trs.putObservaTraspasoPApD(this.model).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getTraspasos();
          this.popupVisibleRet = false;
        }
      },
      error => { console.log('Error', error); });
  }

  showModalCheck(id: number) {
    this.title = 'APROBAR TRASPASO';
    this.model.id = id;
    this.model.estado_id = '';
    this.model.inciso = '';
    this.model.descripcion = '';
    this.popupVisibleChk = true;
    this.resetErrors();
    this.getEstadosTByUsuarioSeguimiento();
  }

  aprobarTraspaso() {
    this.resetErrors();
    this.model.inciso = this.model.estado_id == 26 ? '-' : this.model.inciso;
    this.model.tipo_traspaso = 'D';
    if (this.valid()) {

      this.clicked = true;
      this._trs.putSeguimientoGral(this.model).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getTraspasos();
            this.popupVisibleChk = false;
            toastr.success('Operación realizada exitosamente.');
          }
          this.clicked = false;
        },
        error => { console.log('Error', error); });
    }
  }

  getEstadosTByUsuario() {
    this._trs.getEstadosTByUsuario().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.estados = result.data;
        }
        else { this.estados = []; }
      },
      (error) => { console.log('Error', error); });
  }

  getEstadosTByUsuarioSeguimiento() {
    this._trs.getEstadosTByUsuarioSeguimiento(0, 0).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.tipoSeg = result.data;
        }
        else { this.tipoSeg = []; }
      },
      (error) => { console.log('Error', error); });
  }

  getIncisosPpto() {
    this._trs.getIncisosPpto().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.incisos = result.data;
        }
        else { this.incisos = []; }
      },
      (error) => { console.log('Error', error); });
  }

  valid() {
    let res = true;
    if (!UtilHelper.validator(this.model.estado_id, 'integer')) {
      this.hasError.estado_id = true; res = false;
    }
    if (!UtilHelper.validator(this.model.inciso, 'text')) {
      this.hasError.inciso = true; res = false;
    }
   
    return res;
  }

  resetErrors() {
    this.hasError = { estado_id: false, inciso: false, descripcion: false };
  }


  getObservacion() {
    if (this.model.estado_id != '') {
      if (this.model.estado_id == 25) {
        this.model.descripcion = 'NINGUNA';
        this.esNuevaObs = true;
      }
      else {
        this.getObservacionesLista();
        this.esNuevaObs = false;
        this.model.descripcion = '';
        this.model.observacion_id = 0;
        this.model.estado_id = 26;
      }
    }
  }

  getDescribirObservacion(e: any) {
    var esNueva = this.dataResourceObs.filter(o => o.id == e.value).map(o => o.descripcion).toString();
    if (esNueva == 'Otro') {
      this.esNuevaObs = true;
      this.model.descripcion = '';
    }

    else {
      this.esNuevaObs = false;
      this.model.descripcion = esNueva;
    }

  }

  getObservacionesLista() {
    this._gs.getObservaciones('TRASPASOS').subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceObs = result.data;
        }
        else { this.dataResourceObs = []; }
      },
      (error) => { console.log('Error', error); });
  }


  showModalObs(id: number) {
    this._trs.getTraspasoSeguimientoById({ id: id, tipo: this.ttId == 1 ? 'O' : 'D' }).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.oTraspasos = result.data;
        } else {
          this.oTraspasos = [];
        }
      });
    this.popupVisibleO = true;
  }

}
